<!-- eslint-disable max-len -->
<template>
  <div class="navbar_menu">
    <!-- back Icon -->
    <svg
      v-if="topMenu.left.includes('back')"
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      @click="$router.back()"
    >
      <path
        d="M7.73521 0.493475C7.54043 0.499152 7.3555 0.580407 7.21958 0.720038L0.219582 7.72004C0.078983 7.8607 0 8.05143 0 8.25031C0 8.44919 0.078983 8.63993 0.219582 8.78059L7.21958 15.7806C7.28869 15.8526 7.37147 15.91 7.46306 15.9496C7.55466 15.9892 7.65323 16.0101 7.75301 16.0111C7.85279 16.0121 7.95177 15.9932 8.04415 15.9555C8.13654 15.9178 8.22046 15.862 8.29102 15.7915C8.36158 15.7209 8.41735 15.637 8.45507 15.5446C8.49278 15.4522 8.51169 15.3533 8.51068 15.2535C8.50966 15.1537 8.48875 15.0551 8.44916 14.9635C8.40957 14.8719 8.35211 14.7891 8.28013 14.72L2.5604 9.00031H17.2499C17.3492 9.00172 17.4479 8.98336 17.5401 8.9463C17.6324 8.90924 17.7163 8.85421 17.7871 8.78443C17.8579 8.71465 17.9141 8.63149 17.9524 8.5398C17.9908 8.44811 18.0105 8.34971 18.0105 8.25031C18.0105 8.15092 17.9908 8.05252 17.9524 7.96082C17.9141 7.86913 17.8579 7.78598 17.7871 7.71619C17.7163 7.64641 17.6324 7.59139 17.5401 7.55433C17.4479 7.51727 17.3492 7.49891 17.2499 7.50031H2.5604L8.28013 1.78058C8.38833 1.67521 8.4622 1.53962 8.49206 1.39157C8.52193 1.24351 8.50641 1.08989 8.44752 0.950809C8.38864 0.811725 8.28914 0.693657 8.16204 0.612057C8.03495 0.530457 7.88618 0.489127 7.73521 0.493475Z"
        fill="#333333"
      />
    </svg>
    <!-- back Icon -->
  </div>
</template>

<script>
export default {
  name: "LeftMenu"
};
</script>
